import { fun_PostAction } from "@/api";
import FormConfig from "../formConfig.js";
export default {
  data() {
    return {
      activeNames: FormConfig.configList().map(item => {
        return item.name;
      }), // 默认展开全部面板
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 表单配置
      formConfigList: FormConfig.configList(),
      // 查询表单绑定值
      form: {
        id: null, // 主键
        originalId: null, // 原始主键
        regulators: null, // 区管代码
        constructionNo: null, // 报建编号
        prjName: null, // 工程名称
        buildCorp: null, // 建设单位
        corpLegal: null, // 法定代表
        linkMan: null, // 联系人
        linkTel: null, // 联系人电话
        noteNumber: null, // 立项批准文号
        projectSite: null, // 工程地点
        fundsCharacter: null, // 资金性质
        fundsSources: null, // 资金来源及落实情况
        economicType: null, // 公司经济类型
        recordUnitName: null, // 项目核准或备案单位名称
        approvalName: null, // 批文名称
        buildingLandObtained: null, // 建设用地取得方式
        constructionArea: null, // 房屋建筑工程建筑面积
        structuralHierarchy: null, // 结构层次
        municipalProjectScale: null, // 市政工程规模
        otherProjectScale: null, // 其它工程规模
        constructionUnit: null, // 施工单位
        qualificationCategories: null, // 企业资质类别及等级
        projectManager: null, // 项目经理
        qualificationCategoryLevel: null, // 执业资格类别等级及编号
        managerCertificateNumber: null, // 项目经理安全生产考核合格证书编号
        managementCertificateNumber: null, // 专职安全生产管理人员安全生产考核合格证书编号
        planTimeLimit: null, // 计划工期
        projectCost: null, // 工程造价
        contractScope: null, // 发包范围
        state: null, // 状态
        situation: null, // 资金来源落实情况
        remarks: null, // 备注
        constructionUnitName: null, // 施工单位名称
        managementCertificateName: null, // 专职安全生产管理人员
        sealDate: null, // 盖章日期
        tenderClassNum: null, // 招标类别
        tenderContentNum: null, // 招标内容
        processState: null, // 流程状态
        regulatorsName: null, // 区管代码名称
        projectManagerName: null, // 项目经理名称
        tenderClassName: null, // 招标类别名称
        tenderContentName: null, // 招标内容名称
      },
      // 全局加载
      fullLoading: null,
      // 主键
      id: null,
      /*************************************施工单位项目管理机构配备情况日志表****************************************/
      // 施工单位项目管理机构配备情况日志表loading
      logLoading: false,
      // 查询表单绑定值
      logForm: {},
      // 施工单位项目管理机构配备情况日志表数据
      logTableData: [],
      // 施工单位项目管理机构配备情况日志表数据
      logTableColumns: [
        {
          label: "职务",
          prop: "duty",
        },
        {
          label: "姓名",
          prop: "name",
        },
        {
          label: "职称",
          prop: "positionalTitles",
        },
        {
          label: "证书名称",
          prop: "certificateName",
        },
        {
          label: "级别",
          prop: "level",
        },
        {
          label: "证号",
          prop: "number",
        },
        {
          label: "专业",
          prop: "professional",
        },
      ],
      // 施工单位项目管理机构配备情况日志表分页
      logReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 施工单位项目管理机构配备情况日志表总条数
      logTotal: 0,
      /***************************************联合体单位*******************************************/
      unionLoading: false, // 列表loading状态
      // 查询表单绑定值
      unionForm: {},
      // 表格基础数据
      unionTableColumns: [
        {
          label: "联合体单位名称",
          prop: "unionCorpName"
        },
        {
          label: "联合体单位类型",
          prop: "unionUnitTypeName"
        },
        {
          label: "是否同意",
          slotName: "isAgree"
        },
        {
          label: "不同意理由",
          prop: "disagreeReason"
        },
        {
          label: "确认日期",
          prop: "sealDate"
        },
      ],
      // 表格数据
      unionTableData: [],
      // 联合体单位分页
      unionReqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 联合体单位总条数
      unionTotal: 0,
    }
  },
  // 模板编译完成
  mounted() {
  },
  // 自定义方法
  methods: {
    /**
     * 获取详情
     */
    fun_GetDetail() {
      // 发起请求
      fun_PostAction("/recordDirectlyLogs/detail", {
        id: this.id,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 表格数据
          this.form = data;
          // 直接发包联合体日志表一览
          this.fun_ContractRecordUnionList();
          // 施工单位项目管理机构配备情况日志表一览
          this.fun_OrganizationLogsList();
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
      });
    },
    /**
     * 联合体单位集合
     */
    fun_ContractRecordUnionList(){
      // 主键不为空
      if(this.id){
        // 打开loading
        this.unionLoading = true;
        // 发起请求
        fun_PostAction("/recordDirectlyLogs/recordUnionLogsList", {
          recordDirectlyLogsId: this.id,
        }).then(res => {
          // 解构res.data
          const { result, data } = res.data;
          // 操作成功
          if (result) {
            // 解构data
            const { total, records } = data;
            // 回显table
            this.unionTableData = records;
            // 获取分页总条数
            this.unionTotal = total;
          }
          // 关闭加载
          this.unionLoading = false;
        });
      }
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_ContractRecordUnionLimitChange(e) {
      // 获取每页显示条数
      this.unionReqPageData.size = e;
      // 获取一览表格数据
      this.fun_ContractRecordUnionList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_ContractRecordUnionPageChange(e) {
      // 获取当前页码
      this.unionReqPageData.current = e;
      // 获取一览表格数据
      this.fun_ContractRecordUnionList();
    },
    /**
     * 施工单位项目管理机构配备情况日志表一览
     */
    fun_OrganizationLogsList(){
      // 打开loading
      this.logLoading = true;
      // 发起请求
      fun_PostAction("/recordDirectlyLogs/organizationLogsList", {
        ...this.logReqPageData,
        recordDirectlyLogsId: this.id,
      }).then(res => {
        // 结构res.data
        const { result, data, msg } = res.data;
        // 请求成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.logTableData = records;
          // 获取分页总条数
          this.logTotal = total;
        } else {
          // 提示请求失败的信息
          this.$message.error(msg);
        }
        // 关闭loading
        this.logLoading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_OrganizationLogsLimitChange(e) {
      // 获取每页显示条数
      this.logReqPageData.size = e;
      // 获取一览表格数据
      this.fun_OrganizationLogsList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_OrganizationLogsPageChange(e) {
      // 获取当前页码
      this.logReqPageData.current = e;
      // 获取一览表格数据
      this.fun_OrganizationLogsList();
    },
  }
}